const ko = {
    toHome: '홈페이지로 리디렉션 중입니다...',
    loginSuccess: '로그인 성공',
    loginFailed: '로그인 실패',
    acntNotExist: '계정이 존재하지 않습니다. 확인해주세요',
    acntOrPwdError: '계정 또는 비밀번호 오류',
    checkFailed: '검증 실패',
    selOrg: '참여하고 싶은 조직을 선택해주세요',
    orgTip1: '이 계정이 속한 조직은 존재하지 않으며, 다른 조직에도 속하지 않습니다. 관리자에게 문의하세요. ',
    carousel: '로그인',
    회전목마: '회전목마',
    acnt: '계정',
    enterAcnt: '입력하세요',
    pwd: '비밀번호',
    enterPwd: '비밀번호를 입력하세요',
    remberPwd: '비밀번호 기억하기',
    noOrgTip1: '이 계정은 조직의 구성원이 아닙니다. 관리자에게 문의하세요',
    pageNotFoundTitle: '페이지를 찾을 수 없습니다',
    pageNotFoundTip: '죄송합니다. 방문하신 페이지는 존재하지 않습니다. ',
    goToBackHome: '홈페이지로 돌아가기',
    phoneDisabledTip: '이 전화번호는 비활성화되었습니다. 관리자에게 문의하세요. ',
    welcome: '{{ name }}에 오신 것을 환영합니다'
};

export default ko;